module.exports = __webpack_public_path__ + "static/media/campaignList-loading.960f5ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/campaignList-loading.png
// module id = 1170
// module chunks = 0